export function isIventisEmployee(email: string): boolean {
    if (email == null) {
        return false;
    }
    return email.endsWith("@iventis.com") || email.endsWith("@iventis.co.uk");
}
